import { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { toast } from 'sonner';
import axios from 'axios';
import { API, getAuthHeader } from './api';

export function BookingsManagement() {
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => { fetchBookings(); }, []);

  const fetchBookings = async () => {
    try { const response = await axios.get(`${API}/bookings`, { headers: getAuthHeader() }); setBookings(response.data); }
    catch { /* silent */ }
    finally { setLoading(false); }
  };

  const updateStatus = async (id, status) => {
    try {
      await axios.put(`${API}/bookings/${id}/status?new_status=${status}`, {}, { headers: getAuthHeader() });
      toast.success(`Booking ${status}`);
      fetchBookings();
    } catch (error) { toast.error('Failed to update'); }
  };

  const statusColors = {
    pending: 'bg-yellow-100 text-yellow-700',
    confirmed: 'bg-green-100 text-green-700',
    cancelled: 'bg-red-100 text-red-700'
  };

  return (
    <div>
      <h1 className="text-3xl font-bold text-[#231F20] mb-8 font-['Bricolage_Grotesque']">Advisor Bookings</h1>
      <Card>
        <Table>
          <TableHeader>
            <TableRow><TableHead>Advisor</TableHead><TableHead>Date & Time</TableHead><TableHead>Booked By</TableHead><TableHead>Topic</TableHead><TableHead>Status</TableHead><TableHead>Actions</TableHead></TableRow>
          </TableHeader>
          <TableBody>
            {bookings.map((booking) => (
              <TableRow key={booking.id}>
                <TableCell className="font-medium">{booking.advisor_name}</TableCell>
                <TableCell>{booking.date} at {booking.time_slot}</TableCell>
                <TableCell>{booking.name}<br/><span className="text-xs text-gray-500">{booking.email}</span></TableCell>
                <TableCell className="max-w-xs truncate">{booking.topic}</TableCell>
                <TableCell><Badge className={statusColors[booking.status]}>{booking.status}</Badge></TableCell>
                <TableCell>
                  <Select value={booking.status} onValueChange={(v) => updateStatus(booking.id, v)}>
                    <SelectTrigger className="w-28 h-8"><SelectValue /></SelectTrigger>
                    <SelectContent>{['pending', 'confirmed', 'cancelled'].map(s => <SelectItem key={s} value={s}>{s}</SelectItem>)}</SelectContent>
                  </Select>
                </TableCell>
              </TableRow>
            ))}
            {bookings.length === 0 && !loading && (
              <TableRow><TableCell colSpan={6} className="text-center text-[#58595B] py-8">No bookings yet</TableCell></TableRow>
            )}
          </TableBody>
        </Table>
      </Card>
    </div>
  );
}
